import React from 'react';
import { tUi } from '../utils/uiText';

function StatCard({ label, value, valueClassName = 'text-lg font-semibold text-white tabular-nums' }) {
  return (
    <div className="bg-gray-800 rounded-lg p-3 min-w-0 text-left flex flex-col justify-center">
      <div className="text-xs text-gray-400 leading-snug break-words">{label}</div>
      <div className={`mt-1 break-words ${valueClassName}`}>{value}</div>
    </div>
  );
}

export default function KbStatsCards({ uiLanguage = 'en', stats, compact = false, className = '' }) {
  if (!stats) {
    return (
      <p className={`text-sm text-gray-500 ${className}`.trim()}>
        {tUi(uiLanguage, 'kbStatusLoading')}
      </p>
    );
  }

  const lastSync = stats.last_sync
    ? new Date(stats.last_sync).toLocaleString()
    : tUi(uiLanguage, 'kbNever');

  const gridClass = compact
    ? 'space-y-3'
    : 'grid grid-cols-2 md:grid-cols-5 gap-3';

  if (compact) {
    return (
      <div className={`${gridClass} ${className}`.trim()}>
        <div className="grid grid-cols-3 gap-3">
          <StatCard label={tUi(uiLanguage, 'kbIndexed')} value={stats.indexed_files ?? 0} />
          <StatCard label={tUi(uiLanguage, 'kbPending')} value={stats.pending_files ?? 0} />
          <StatCard label={tUi(uiLanguage, 'kbNoindexStat')} value={stats.noindex_files ?? 0} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <StatCard label={tUi(uiLanguage, 'kbChunks')} value={stats.total_chunks ?? 0} />
          <StatCard
            label={tUi(uiLanguage, 'kbLastSync')}
            value={lastSync}
            valueClassName="text-xs font-medium text-gray-200 leading-snug"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`${gridClass} ${className}`.trim()}>
      <StatCard label={tUi(uiLanguage, 'kbIndexed')} value={stats.indexed_files ?? 0} />
      <StatCard label={tUi(uiLanguage, 'kbPending')} value={stats.pending_files ?? 0} />
      <StatCard label={tUi(uiLanguage, 'kbNoindexStat')} value={stats.noindex_files ?? 0} />
      <StatCard label={tUi(uiLanguage, 'kbChunks')} value={stats.total_chunks ?? 0} />
      <StatCard
        label={tUi(uiLanguage, 'kbLastSync')}
        value={lastSync}
        valueClassName="text-xs font-medium text-gray-200 leading-snug"
      />
    </div>
  );
}
